import { Sheet } from 'react-modal-sheet';
import styled from 'styled-components';
import ModalTopBg from '/img/modal/modal-top.png';
import { SwitchButton } from '../common/SwichButton';
import WaringIcon from '/img/waring-icon.png';
import { CommonButton } from '../common/CommonButton';
import { useState } from 'react';
import { ThirdAgreePrivacy } from './ThirdAgreePrivacy';
import { useApiHook } from '../../hook/useApiHook';
import { MODAL_TYPE, modalStore } from '../../store/modalStore';

export const AgreePrivacy = () => {
  const { isVisiblePrivacy, hidePrivacyModal, showModal } = modalStore();
  const [agreeStatus, setAgreeStatus] = useState<boolean | null>(null);
  const [thirdAgree, setThirdAgree] = useState(false);
  const { postAgreePrivacy } = useApiHook();

  const clickCheck = () => {
    // 선택 하지 않음
    if (agreeStatus === null) {
      showModal({ modalType: MODAL_TYPE.CHECK_AGREE });
      return;
    }

    // 비동의
    if (!agreeStatus) {
      showModal({
        modalType: MODAL_TYPE.REAL_NOT_AGREE,
        commonCallback2: () => {
          hidePrivacyModal();
          setAgreeStatus(null);
        },
      });
      return;
    }

    // 동의 시 api 호출
    postAgreePrivacy()
      .then(() => {
        hidePrivacyModal();
        showModal({
          modalType: MODAL_TYPE.COMPLETE_AGREE,
          commonCallback2: () => {
            hidePrivacyModal();
            setAgreeStatus(null);
          },
        });
      })
      .catch((e) => {
        alert('에러가 발생했습니다. 잠시후 다시 시도해주세요.');
        console.log(e);
      });
  };
  return (
    <>
      <Sheet
        isOpen={isVisiblePrivacy}
        onClose={() => {
          hidePrivacyModal();
          setAgreeStatus(null);
        }}
        tweenConfig={{ ease: 'easeOut', duration: 0.2 }}
        draggable={true}
        detent={'content-height'}
      >
        <Backdrop onTap={() => {}} />
        <Sheet.Container style={{ backgroundColor: 'transparent' }}>
          <Container>
            <TitleContainer>
              <Title>참가권 획득을 축하드립니다!</Title>
            </TitleContainer>
            <Content>
              <AgreeText>
                토너먼트 참가를 위한 개인정보 3자 제공에 동의해 주세요
                <br />
                <span>9월 24일 23시 59분까지</span> 동의해야합니다.
              </AgreeText>

              <AgreeSwitchArea>
                <AgreePrivacyText>
                  토너먼트 참가를 위한 3자 제공 동의{' '}
                  <span onClick={() => setThirdAgree(true)}>[ ▶ 보기]</span>
                </AgreePrivacyText>
                <SwitchButton agreeStatus={agreeStatus} setAgreeStatus={setAgreeStatus} />
              </AgreeSwitchArea>

              <WaringTextContainer>
                <img src={WaringIcon} />
                <WaringText>개인정보 제공에 미동의 시 토너먼트에 참가할 수 없습니다.</WaringText>
              </WaringTextContainer>

              <CommonButton text="확인" click={clickCheck} />
            </Content>
          </Container>
        </Sheet.Container>
      </Sheet>

      <ThirdAgreePrivacy thirdAgree={thirdAgree} close={() => setThirdAgree(false)} />
    </>
  );
};

const Backdrop = styled(Sheet.Backdrop)`
  background-color: rgb(0, 0, 0, 0.5) !important;
`;

const TitleContainer = styled.div`
  height: 64px;
  padding-top: 35px;
  background-image: url(${ModalTopBg});
  background-size: cover;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding-left: 20px;
  padding-right: 20px;
`;

const Title = styled.h3`
  color: #fbf6d5;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.17px;
`;

const Container = styled.div``;

const Content = styled.div`
  background: #302e2d;
  padding: 0px 10px 30px 10px;
`;

const AgreeText = styled.p`
  color: #eee;
  text-align: center;
  font-size: 14px;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.84px;
  margin-bottom: 12px;

  span {
    color: #f86855;
  }
`;

const AgreePrivacyText = styled.h4`
  color: #b2b2b2;
  text-align: center;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.56px;
  margin-bottom: 20px;
  span {
    color: #d3ff7e;
    margin-left: 5px;
  }
`;

const AgreeSwitchArea = styled.div`
  padding: 21px 20px 18px 20px;
  border-radius: 9px;
  background: #201f1e;
`;

const WaringTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  margin-top: 12px;

  img {
    margin-right: 3px;
  }
`;

const WaringText = styled.h4`
  color: #f86855;
  font-size: 13px;
  line-height: 17px;
  letter-spacing: -0.52px;
`;
